// extracted by css-extract-rspack-plugin
export default {"root":"root-kgCm24","control":"control-VQ7KUg","text":"text-mzxfZv text-body-base","labelInvalid":"labelInvalid-DwA9jy"};